module.exports = __webpack_public_path__ + "img/ftIconac.0911d3df.png";